export const ImageAssets = {
  idCardFront: "/images/idcard_front.png",
  lisence: "/images/lisence.png",
  qrcode: "/images/qrcode.jpg",
  barcode: "/images/bar_code.png",
  zfb: "/images/zfb.png",
  scan: "/images/scan.png",
  tp: "/images/tp.png",
  logo: "/images/logo.jpg"
}